import { BleDeviceTypes } from '@/constants/ble'
import {
  ElectronicBloodPressureMonitorValues,
  MedicalBloodPressureMonitorValues,
  ElectronicThermometerValues,
  BloodSugarLevelMeasurementValues,
  Spo2MonitorMightySatValues,
  Spo2MonitorTm1121Values,
  NoncontactThermometerValues,
  BodyCompositionMonitorValues
} from '@/types/ble'

export const electronicBloodPressureMonitorGenerator = (function* electronicBloodPressureMonitorGenerator() {
  while (true) {
    yield {
      deviceType: BleDeviceTypes.ELECTRONIC_BLOOD_PRESSURE_MONITOR,
      bytes: new ArrayBuffer(0),
      datetime: new Date(),
      systolicPressure: Math.floor(Math.random() * 100),
      diastolicPressure: Math.floor(Math.random() * 100),
      pr: Math.floor(Math.random() * 100)
    } as ElectronicBloodPressureMonitorValues
  }
})()

export const medicalBloodPressureMonitorGenerator = (function* medicalBloodPressureMonitorGenerator() {
  while (true) {
    yield {
      deviceType: BleDeviceTypes.MEDICAL_BLOOD_PRESSURE_MONITOR,
      bytes: new ArrayBuffer(0),
      datetime: new Date(),
      systolicPressure: Math.floor(Math.random() * 100),
      diastolicPressure: Math.floor(Math.random() * 100),
      pr: Math.floor(Math.random() * 100),
      measurementTime: new Date()
    } as MedicalBloodPressureMonitorValues
  }
})()

export const electronicThermometerGenerator = (function* electronicThermometerGenerator() {
  while (true) {
    yield {
      deviceType: BleDeviceTypes.ELECTRONIC_THERMOMETER,
      bytes: new ArrayBuffer(0),
      datetime: new Date(),
      temperature: Math.floor(Math.random() * 100)
    } as ElectronicThermometerValues
  }
})()

export const bloodSugarLevelMeasurementGenerator = (function* bloodSugarLevelMeasurementGenerator() {
  while (true) {
    yield {
      deviceType: BleDeviceTypes.BLOOD_SUGAR_LEVEL_MEASUREMENT,
      bytes: new ArrayBuffer(0),
      datetime: new Date(),
      glucose: Math.random() * 100
    } as BloodSugarLevelMeasurementValues
  }
})()

export const spo2MonitorMightySatGenerator = (function* spo2MonitorMightySatGenerator() {
  while (true) {
    yield {
      deviceType: BleDeviceTypes.SPO2_MONITOR_MIGHTY_SAT,
      bytes: new ArrayBuffer(0),
      datetime: new Date().toISOString(),
      spo2: Math.floor(Math.random() * 100),
      pr: Math.floor(Math.random() * 100)
    } as Spo2MonitorMightySatValues
  }
})()

export const spo2MonitorTm1121Generator = (function* spo2MonitorTm1121Generator() {
  while (true) {
    yield {
      deviceType: BleDeviceTypes.SPO2_MONITOR_TM1121,
      bytes: new ArrayBuffer(0),
      datetime: new Date(),
      spo2: Math.floor(Math.random() * 100),
      pr: Math.floor(Math.random() * 100)
    } as Spo2MonitorTm1121Values
  }
})()

export const noncontactThermometerGenerator = (function* noncontactThermometerGenerator() {
  while (true) {
    yield {
      deviceType: BleDeviceTypes.NONCONTACT_THERMOMETER,
      bytes: new ArrayBuffer(0),
      datetime: new Date(),
      temperature: Math.floor(Math.random() * 100),
      measurementTime: new Date()
    } as NoncontactThermometerValues
  }
})()

export const bodyCompositionMonitorGenerator = (function* bodyCompositionMonitorGenerator() {
  while (true) {
    yield {
      deviceType: BleDeviceTypes.BODY_COMPOSITION_MONITOR,
      bytes: new ArrayBuffer(0),
      datetime: new Date(),
      weight: Math.floor(Math.random() * 100),
      measurementTime: new Date()
    } as BodyCompositionMonitorValues
  }
})()
